import emailjs from "emailjs-com";

export const sendEmail = (templateParams) => {
	return emailjs.send(
		"service_i898blv",
		"template_qw5h04r",
		templateParams
	);
};
